import comp from "./DeleteDialogueBox";
export default comp;
